import moment from 'moment';

export const WEEKEND_WORKING = 'WEEKEND_WORKING';
export const WEEKEND_WORKING_PRIVILEGE = 'REQUEST_WEEKEND_WORKING_HOURS';

/** Dates come back either as ISO strings or as [year, month, day] arrays. */
export const toMoment = (value) => {
  if (Array.isArray(value)) {
    return moment({ year: value[0], month: value[1] - 1, day: value[2] });
  }
  return moment(value);
};

export const formatDate = (value) => toMoment(value).format('DD MMM YYYY');

/** Header text for a list of dates: all of them up to three, then "+N more". */
export const datesText = (dates = []) => {
  const list = [...dates].sort().map((d) => formatDate(d));
  if (list.length <= 3) return list.join(', ');
  return `${list.slice(0, 2).join(', ')} +${list.length - 2} more`;
};

export const isWeekend = (date) => {
  const day = date.day();
  return day === 0 || day === 6;
};

export const STATUS_LABEL = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const STATUS_COLOR = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
};

/** "Pending approval from A, B" text for a pending request or task, else null. */
export const pendingFrom = (item) =>
  item?.status === 'PENDING' && (item.approverNames || []).length
    ? item.approverNames.join(', ')
    : null;

/** Last manager comment on a request, if any. */
export const lastDecision = (request) => {
  const approvals = request?.approvals || [];
  return approvals.length ? approvals[approvals.length - 1] : null;
};
